import React from 'react';
import { ENGINE_ICON_MAP } from '@laigu/constants';

import MyIcon from '../my-icon';

const replaceBrowser = (browser_family: string): string => {
  if (browser_family) {
    // 将空格和「.」替换为「-」
    return browser_family.toLowerCase().replace(/(\s|\.)+/g, '-');
  }
  return '';
};

type BrowserIconProps = {
  browser?: string;
  className?: string;
};

const BrowserIcon = ({ browser, className }: BrowserIconProps): JSX.Element | null => {
  if (!browser) {
    return null;
  }
  const browerLowerCase = replaceBrowser(browser);
  const iconClassName = ENGINE_ICON_MAP[browerLowerCase];
  return (
    <MyIcon
      type={`ecoboost-iconfont${iconClassName || 'unknown'}`}
      className={className}
      title={browerLowerCase || ''}
    />
  );
};

BrowserIcon.defaultTypes = {
  browser: '',
  className: ''
};

export default BrowserIcon;
